import React from 'react';
import * as chartjs from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartJSDataLabels from 'chartjs-plugin-datalabels';
import { Typography } from 'antd';

chartjs.Chart.register(ChartJSDataLabels);

interface Props {
  productsCounter: any,
  t: any,
  productType: 'licenses' | 'sensors'
}

/* eslint-disable i18next/no-literal-string */
const SensorsByAreaAndType = ({ productsCounter, t, productType }: Props) => {
  console.log(productsCounter);
  const { Text } = Typography;
  const labels = Object.keys(productsCounter || {}).map(label => t(label));
  let dataType1;
  let dataType2;
  let dataType3;
  let dataType4;
  if (productType === 'licenses') {
    dataType1 = Object.keys(productsCounter || {}).map(key => productsCounter[key].licenses.type1);
    dataType2 = Object.keys(productsCounter || {}).map(key => productsCounter[key].licenses.type2);
    dataType3 = Object.keys(productsCounter || {}).map(key => productsCounter[key].licenses.type3);
    dataType4 = Object.keys(productsCounter || {}).map(key => productsCounter[key].licenses.type4);
  } else {
    dataType1 = Object.keys(productsCounter || {}).map(key => productsCounter[key].sensors.type1);
    dataType2 = Object.keys(productsCounter || {}).map(key => productsCounter[key].sensors.type2);
    dataType3 = Object.keys(productsCounter || {}).map(key => productsCounter[key].sensors.type3);
    dataType4 = Object.keys(productsCounter || {}).map(key => productsCounter[key].sensors.type4);
  }


  return (
        <>
            <div className='titleBox'>
                <Text className='titleBlackBox'>{productType === 'sensors' ?  t('ACTIVE_SENSOR_BY_TYPE_AND_AREA')
                  : t('ACTIVE_LICENSES_BY_TYPE_AND_AREA')}</Text>
            </div>

            <Text className='titleBlackBox'></Text>
            <div className='boxActiveSensors'>

                <div> <Bar data={{
                  labels,
                  datasets: [
                    {
                      label: 'Tipo 1',
                      data: dataType1,
                      backgroundColor: 'rgba(255, 99, 132, 0.2)'
                    },
                    {
                      label: 'Tipo 2',
                      data: dataType2,
                      backgroundColor: 'rgba(54, 162, 235, 0.2)'
                    },
                    {
                      label: 'Tipo 3',
                      data: dataType3,
                      backgroundColor: 'rgba(255, 206, 86, 0.2)'
                    },
                    {
                      label: 'Tipo 4',
                      data: dataType4,
                      backgroundColor: 'rgba(45, 192, 192, 0.2)'
                    }
                  ]
                }} />
                </div>
            </div>
        </>
  );
};

export default SensorsByAreaAndType;
